import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import settingsIcon from '../../../../images/icons/settings.svg';
import infoIcon from '../../../../images/icons/info.svg';
import { SetComponentLanguage, ApiRequest } from '../../../../helpers';
import { DymoPrint } from '../../../../lib/labels/DYMO.print';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class FlexpassPoster extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isEventSettingsOpen: false,
            isModalOpen: false,
            targetUserId: null,
        }
    }

    toggleEventSettings = () => {
        let isEventSettingsOpen = this.state.isEventSettingsOpen;
        isEventSettingsOpen = !isEventSettingsOpen;
        this.setState({ isEventSettingsOpen });
    }

    handleClick = (e) => {
        if (this.node && this.node.contains(e.target) || 
                e.target.id === `poster-settings-b-${this.props.flexpass.id}` || 
                    e.target.id === `poster-settings-i-${this.props.flexpass.id}`) {
            return;
        }
        this.handleClickOutside();
    }

    handleClickOutside = () => {
        if (this.state.isEventSettingsOpen) {
            const isEventSettingsOpen = false;
            this.setState({ isEventSettingsOpen });
        }
    }

    toggleAlertModal = (e) => {
        e.preventDefault();
        this.setState({
            isModalOpen: !this.state.isModalOpen,
        });
    }

    confirmAlertModal = async () => {
        try {
            const responseVenue = await getVenue(this.props.event.venue_id);
            console.log('Get Event Venue: ', responseVenue);
            DymoPrint(this.props.currentPrinter, 'sig');
            this.setState({
                isModalOpen: false
            });
        } catch (error) {
            console.log(error);
        }

        async function getVenue(venueId) {
            return await ApiRequest(`/venues/${venueId}`);
        }
    }

    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    render() { 
        return ( 
            <React.Fragment>
                <div className="showtix-event__poster showtix-flexpass__poster">
                    <div className="showtix-badge showtix-background__primary-1">{strings.flexpass}</div>
                    <div className="showtix-event__bar">
                        {
                            this.props.user.role !== undefined && (this.props.user.client_id === this.props.current_client_id || !this.props.current_client_id) &&
                            <button
                                id={`poster-settings-b-${this.props.flexpass.id}`}
                                className="showtix-event__settings showtix-background__grey-3"
                                onClick={this.toggleEventSettings}
                            >
                                <img
                                    id={`poster-settings-i-${this.props.flexpass.id}`}
                                    src={settingsIcon} alt="Click to open the Event Settings"
                                />
                            </button>
                        } 
                        <button
                            className="showtix-event__info showtix-background__grey-3"
                            onClick={() => this.props.toggleDetails(this.props.flexpass.id, 'flexpass')}
                            id={this.props.flexpass.id}
                        >
                            <img src={infoIcon} alt="Click here to open the Event Details" />
                        </button>
                    </div>
                    <div
                        ref={node => this.node = node}
                        className={"showtix-event__panel showtix-event__settings__panel showtix-background__grey-3" + (this.state.isEventSettingsOpen ? ' is-active' : '')}>
                        <ul>
                            {this.props.user.role !== 'box-office' && this.props.status !== 'past' &&
                                <React.Fragment>
                                    <li><Link to={`/create-flexpass/${this.props.flexpass.id}`}>{strings.edit}</Link></li>
                                    <li>
                                        <button
                                            onClick={() => this.props.toggleConfirmDeleteFlexpass(this.props.flexpass.id)}
                                        >{strings.delete}</button>
                                    </li>
                                </React.Fragment>
                            }
                            <li><Link to={`/search/flexpass/${this.props.flexpass.id}`}>{strings.transactionsSearch}</Link></li>
                            {this.props.user.role !== 'box-office' &&
                                <React.Fragment>
                                    <li><button
                                        onClick={() => this.props.getAccountEventReport(this.props.flexpass.id, 'flexpass')}
                                    >{strings.accountReport}</button></li>
                                </React.Fragment>
                            }
                        </ul>
                    </div>
                    
                    {!this.props.flexpass.poster_graphic_url &&
                        <div className="showtix-event__poster__title">
                            {this.props.flexpass.name}
                        </div>
                    }
                    <div className="showtix-event__poster__image">
                        {this.props.flexpass.poster_graphic_url ?
                            <img src={`${this.props.flexpass.poster_graphic_url}`} alt={this.props.flexpass.short_name} />
                            :
                            <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_flex.jpg"} alt={this.props.flexpass.short_name} />
                        }
                    </div>
                </div>
            </React.Fragment>
         )
    }
}

FlexpassPoster.propTypes = {
    event: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.number,
        status: PropTypes.string,
        poster_graphic_url: PropTypes.string,
        name: PropTypes.string
    }),
    toggleConfirmDeleteEvent: PropTypes.func,
    toggleDetails: PropTypes.func
}
 
export default FlexpassPoster;


// WEBPACK FOOTER //
// ./src/components/EventListing/Flexpass/FlexpassPoster/FlexpassPoster.js